class FieldGroup {
  constructor(data) {
    this.pk = data?.pk;
    this.name = data?.name || 'NA';
    this.parent_pk = data?.parent_pk ? data?.parent.pk : data?.parent_pk;
    this.parent_name = data?.parent_pk ? data?.parent.name : 'NA';
    this.default_field_group_visibility = data?.default_field_group_visibility;
    this.visible_fields = data?.default_field_group_visibility?.visible ? data.default_field_group_visibility?.visible : [];
    this.hidden_fields = data?.default_field_group_visibility?.hidden ? data.default_field_group_visibility?.hidden : [];
    const entityType = data?.config_master?.entity_name ? data.config_master.entity_name.split('_')[1] : '';
    this.entity_name = entityType ? entityType.charAt(0).toUpperCase() + entityType?.slice(1) : '';
    const attributeName = data?.config_master?.attribute_name ? data.config_master.attribute_name.split('_') : [];
    this.attribute_name = attributeName?.length ? attributeName[0]?.charAt(0).toUpperCase() + attributeName[0]?.slice(1) + ' ' + attributeName[1]?.charAt(0).toUpperCase() + attributeName[1]?.slice(1) : '';
  }
}
export default FieldGroup;